import React, { useEffect, useRef, useState } from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import "../styles.scss";
import API from "../../api/api";
import "./styles.scss";
import TicketFooter from "./TicketFooter";
import { useSelector } from "react-redux";
import TicketList from "./TicketList";
import TicketChat from "./TicketChat";
import TicketUserInfo from "./TicketUserInfo";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import TuneIcon from "@mui/icons-material/Tune";
import PupringProperties from "../../components/tabs/pupringProperties";
import useQueryTicketSystem from "../../Hooks/useQueryTicketSystem/useQueryTicketSystem";
import TicketSystemFilter from "../../components/filter/TicketSystemFilter/TicketSystemFilter";
import { useParams, useNavigate } from "react-router-dom";

export const TicketsSystem = ({ setShowSideBar }) => {
  const auth = useSelector((state) => state.user);
  const { id: savedItem } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [pupringId, setPupringId] = useState(null);
  const [filter, setFilter] = useState(true);
  const boolRef = useRef(false);
  const [dropDownTag, setDropDownTag] = useState(false);
  const [selectedTag, setSelectedTag] = useState(null);
  const [updatedData, setUpdatedData] = useState(savedItem ? false : true);
  const [isPaginationLoading, setIsPaginationLoading] = useState(false);

  // Track URL-based IDs separately from user-applied IDs
  const [urlBasedIds, setUrlBasedIds] = useState(savedItem ? [savedItem] : []);
  const [userAppliedIds, setUserAppliedIds] = useState([]);

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
    _id: savedItem ? [savedItem] : [],
    po_number: [],
    all_tag: updatedData,
  });

  // Function to remove URL IDs and update URL
  const removeUrlIdsFromFilter = () => {
    if (urlBasedIds.length > 0) {
      // Remove URL from browser
      navigate('/tickets-system', { replace: true });
      
      // Clear URL-based IDs from state
      setUrlBasedIds([]);
      
      // Update pagination model to only include user-applied IDs
      setPaginationModel(prev => ({
        ...prev,
        _id: userAppliedIds
      }));
    }
  };

  // Enhanced setPaginationModel wrapper to handle URL ID removal
  const handlePaginationModelUpdate = (newModel) => {
    // Check if this is an all_tag filter update
    if (typeof newModel === 'function') {
      setPaginationModel(prev => {
        const updatedModel = newModel(prev);
        return updatedModel;
      });
      return;
    }

    const isAllTagUpdate = newModel.hasOwnProperty('all_tag');
    
    // If this is a custom filter update (not just pagination) or all_tag update, remove URL IDs
    if (typeof newModel === 'object' && 
        (!newModel.hasOwnProperty('page') && !newModel.hasOwnProperty('pageSize')) || 
        isAllTagUpdate) {
      removeUrlIdsFromFilter();
      
      // If user is manually adding IDs, track them separately (but not for all_tag updates)
      if (newModel._id && Array.isArray(newModel._id) && !isAllTagUpdate) {
        setUserAppliedIds(newModel._id);
      }
    }
    
    setPaginationModel(prev => ({
      ...prev,
      ...newModel
    }));
  };

  // Watch for URL parameter changes
  useEffect(() => {
    if (savedItem && savedItem !== urlBasedIds[0]) {
      setUrlBasedIds([savedItem]);
      setPaginationModel(prev => ({
        ...prev,
        _id: [savedItem, ...userAppliedIds]
      }));
    }
  }, [savedItem]);

  const { isLoading, rows, pageInfo } = useQueryTicketSystem(paginationModel, setIsPaginationLoading);

  // useEffect(() => {
  //   setTimeout(() => {
  //     setPaginationModel({
  //       _id: savedItem?.split(","),
  //     });
  //   }, 700);
  // }, [savedItem]);

  const handleReset = async () => {
    // Clear both URL-based and user-applied IDs
    setUrlBasedIds([]);
    setUserAppliedIds([]);
    
    // Remove URL from browser if it exists
    if (savedItem) {
      navigate('/tickets-system', { replace: true });
    }
    
    setPaginationModel({
      _id: [],
      order_status:
        pageInfo.order_status === "all" ? [] : pageInfo.order_status,
      multiple_order_status: [],
      po_number: [],
      first_date: "",
      last_date: "",
      name: [],
      invoiceStatus: [],
      color: [],
      factory_color: [],
      remarks: "",
      admin_remarks: "",
      factory_note: "",
      customer_note: "",
      all_remarks: false,
      all_admin_remarks: false,
      all_factory_note: false,
      all_customer_note: false,
      tag_blue: [],
      tag_red: [],
      all_tag_blue: "",
      all_tag_red: "",
      all_tag: [],
      bool: boolRef.current,
    });
    boolRef.current = !boolRef.current;
  };
  const [displayImages, setDisplayImages] = React.useState(null);
  const [getTags, setGetTags] = useState();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await API.get(`/customer/get-tags`);
        setGetTags(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <Sidebar />
      <Navbar setShowSideBar={setShowSideBar} />
      <Container maxWidth="100" className="contailer-fluid">
        <div className={`tickets-system ${"active-image"}`}>
          <h2 style={{ marginBottom: filter ? "10px" : 0 }}>Tickets System</h2>
          {filter && (
            <TicketSystemFilter
              setUpdatedData={setUpdatedData}
              getUpdatedData={updatedData}
              savedItem={savedItem}
              shareDoc={false}
              setPaginationModel={handlePaginationModelUpdate}
              pageInfo={pageInfo}
            />
          )}
          {data ? (
            <Box sx={{
              mt:filter?"20px":""
            }}>
              {auth.type === "admin" ? (
                <Box
                  sx={{
                    display: "flex",
                    p: "15px",
                    background: "white",
                    borderRadius: "20px",
                  }}
                >
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography sx={{ ml: "20px" }}>Factory Color</Typography>
                    <PupringProperties
                      factoryColor={true}
                      updatedData={updatedData}
                      setUpdatedData={setUpdatedData}
                      rows={rows}
                      data={data}
                      isLoading={isLoading}
                      pageInfo={pageInfo}
                      setPaginationModel={handlePaginationModelUpdate}
                    />
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography sx={{ ml: "20px" }}>Customer Color</Typography>
                    <PupringProperties
                      customerColor={true}
                      updatedData={updatedData}
                      setUpdatedData={setUpdatedData}
                      rows={rows}
                      data={data}
                      isLoading={isLoading}
                      pageInfo={pageInfo}
                      setPaginationModel={handlePaginationModelUpdate}
                    />
                  </Box>
                </Box>
              ) : (
                <Box sx={{ display: "flex", flexDirection: "column" , p: "15px",
                background: "white",
                borderRadius: "20px",}}>
                  <Typography sx={{ ml: "20px" }}>Customer Color</Typography>
                  <PupringProperties
                    customerColor={true}
                    updatedData={updatedData}
                   setUpdatedData={setUpdatedData}
                    rows={rows}
                    data={data}
                    isLoading={isLoading}
                    pageInfo={pageInfo}
                    setPaginationModel={handlePaginationModelUpdate}
                  />
                </Box>
              )}
            </Box>
          ) : null}
          <div
            className={`ticket-chat ${filter ? "with-filter" : ""} ${
              data ? "with-action-btns" : ""
            }`}
          >
            <div className="ticket-list">
              <div className="ticket-chat-header">
                <h3>Order List</h3>
                <div className="filter-btns">
                  <Button
                    className="btn-primary"
                    disabled={isLoading}
                    title="all tag filter"
                    onClick={() => {
                      // Remove URL IDs when applying all tag filter
                      removeUrlIdsFromFilter();
                      setUpdatedData((e) => !e);
                      // Also update pagination model to reflect the change
                      handlePaginationModelUpdate({ all_tag: !updatedData });
                    }}
                  >
                   {updatedData?" No tag ":" All tag "}
                  </Button>
                  <Button
                    className="btn-primary"
                    title="Reset"
                    onClick={handleReset}
                  >
                    <RestartAltIcon />
                  </Button>
                  <Button
                    className="btn-primary"
                    title="Filter"
                    onClick={() => setFilter((e) => !e)}
                  >
                    <TuneIcon />
                  </Button>
                  
                </div>
              </div>
              <div className="ticket-list-items">

                <TicketList
                isPaginationLoading={isPaginationLoading}
                  pageInfo={pageInfo}
                  setSelectedTag={setSelectedTag}
                  rows={rows}
                  setData={setData}
                  setPupringId={setPupringId}
                  isLoading= {isLoading}
                  setPaginationModel={handlePaginationModelUpdate}
                  pupringId={pupringId}
                />
              </div>
            </div>
            <div className="ticket-chat-box">
              <div className="ticket-chat-header">
                <h3>{data?.po_id}</h3>
              </div>
             
              <TicketChat
                data={data}
                displayImages={displayImages}
              />
              <TicketFooter
                {...{
                  data,
                  setDropDownTag,
                  dropDownTag,
                  getTags,
                  displayImages,
                  setDisplayImages,
                  isLoading,
                  setPaginationModel: handlePaginationModelUpdate,
                  pageInfo,
                  selectedTag,
                  setSelectedTag,
                }}
                updatedData={updatedData}
                setUpdatedData={setUpdatedData}
              />
            </div>
            <div className="ticket-user-info">
              <div className="ticket-chat-header">
                <h3>Order Info</h3>
              </div>
              <TicketUserInfo data={data} />
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};